import { render } from "./VehicleDeviationCard.vue?vue&type=template&id=3ca63653"
import script from "./VehicleDeviationCard.vue?vue&type=script&lang=ts"
export * from "./VehicleDeviationCard.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon,QSpinner});qInstall(script, 'directives', {Ripple});
